package team.platforma.aicombo.activity.main.component.profile

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.navigation_profile_title
import aicombo.composeapp.generated.resources.user_outline
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import team.platforma.aicombo.activity.main.component.profile.fragment.ProfileFragment
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.extra_nav.component.component_of_activity.Component

object ProfileComponent : Component(
    route = "profile_component",
    fragments = listOf(ProfileFragment),
    label = Res.string.navigation_profile_title,
    icon = { selected ->
//        SimpleNavIcon(selected, Res.drawable.user_outline)
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(Res.drawable.user_outline),
                contentDescription = null,
                tint = if (selected) AppColors.text().primary else AppColors.text().caption,
                modifier = Modifier.size(24.dp)
            )
        }
    },
)